import classNames from 'classnames';
import type { FunctionComponent, MouseEventHandler, ReactNode, Ref, SVGProps } from 'react';

import styles from './VoidLink.module.scss';

export interface Props {
    children?: ReactNode;
    className?: string;
    disabled?: boolean;
    iconClassName?: string;
    iconLeft?: FunctionComponent<SVGProps<SVGSVGElement>> | null;
    iconRight?: FunctionComponent<SVGProps<SVGSVGElement>> | null;
    labelClassName?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    ref?: Ref<HTMLButtonElement>;
    id?: string;
}

export function VoidLink({
    children,
    className,
    disabled,
    iconClassName,
    labelClassName,
    iconLeft: IconLeft,
    iconRight: IconRight,
    onClick,
    ref,
}: Props) {
    return (
        <button
            className={classNames(className, styles.link, {
                [styles.disabled]: disabled,
            })}
            disabled={disabled}
            onClick={onClick}
            ref={ref}
        >
            {IconLeft && (
                <IconLeft className={classNames(styles.icon, styles.left, iconClassName)} />
            )}
            {children && (
                <span className={classNames(styles.label, labelClassName)}>{children}</span>
            )}
            {IconRight && (
                <IconRight className={classNames(styles.icon, styles.right, iconClassName)} />
            )}
        </button>
    );
}
